// src/features/auth/components/ResetPasswordForm.js
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useParams } from 'react-router-dom';
import Input from '../../../shared/components/Input';
import Button from '../../../shared/components/Button';
import { useAuth } from '../hooks/useAuth';
import Alert from '../../../shared/components/Alert';

const schema = yup.object({
  password: yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .required('Password is required'),
  password_confirmation: yup.string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required'),
});

const ResetPasswordForm = () => {
  const { token } = useParams();
  const { resetPassword, isLoading, error, message, clearError, clearMessage } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    await resetPassword({ ...data, token });
  };

  return (
    <div className="max-w-md w-full mx-auto">
      <div className="text-center mb-8">
           <img 
  src="/avyukt-healthcare-logo.png" 
  alt="Logo" 
  className="mx-auto h-16 w-auto mb-4"
/>
        {/* <h2 className="text-3xl font-bold text-gray-900">Reset Password</h2> */}
        <p className="text-gray-600 mt-2">
          Enter your new password below
        </p>
      </div>

      {error && (
        <Alert type="error" message={error} onClose={clearError} />
      )}

      {message && (
        <Alert type="success" message={message} onClose={clearMessage} />
      )}

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <Input
          label="New Password"
          type="password"
          {...register('password')}
          error={errors.password?.message}
          placeholder="Enter new password"
        />

        <Input
          label="Confirm New Password"
          type="password"
          {...register('password_confirmation')}
          error={errors.password_confirmation?.message}
          placeholder="Confirm new password"
        />

        <Button
          type="submit"
          variant="primary"
          isLoading={isLoading}
          className="w-full"
        >
          Reset Password
        </Button>
      </form>
    </div>
  );
};

export default ResetPasswordForm;